/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Family_NativeInputs */

const cs_portals_family_native = /** @type {(inputs: Portals_Family_NativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připravujeme`)
};

const en_portals_family_native = /** @type {(inputs: Portals_Family_NativeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coming soon`)
};

/**
* | output |
* | --- |
* | "Coming soon" |
*
* @param {Portals_Family_NativeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_family_native = /** @type {((inputs?: Portals_Family_NativeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Family_NativeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_family_native(inputs)
	return cs_portals_family_native(inputs)
});